//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../Uk/Header";
//Install
import Footer from "../../../Uk/Footer";
//Install
import Item from "../../../Uk/Shortcode/Project/Item";
//Install
import Data from "../../../Uk/Shortcode/Project/Data/Image";
//Install
import House from "../../../Uk/Shortcode/Project/House/Image";
//Install
import Hotel from "../../../Uk/Shortcode/Project/Hotel/Image";
//Install
import Water from "../../../Uk/Shortcode/Project/Water/Image";
//Install
import Office from "../../../Uk/Shortcode/Project/Office/Image";
//Install
import Formula from "../../../Uk/Shortcode/Project/Formula/Image";
//Install
import Factory from "../../../Uk/Shortcode/Project/Factory/Image";
//Install
import Hospital from "../../../Uk/Shortcode/Project/Hospital/Image";
//Install
import Education from "../../../Uk/Shortcode/Project/Education/Image";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Projects : Temas Electrical Contracting"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Delivering Sustainable and Reliable Energy Solutions That Empower The Future."
        //Element
        let URL = "https://en.temaselektrik.com/projects"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Completed Projects"
                                        )
                                    )
                                )
                            ),
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB c3937k" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Housing"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(House, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Company"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Project"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Location"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Date"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Orman Ada Residential Buildings", Project: "Electrical Work for 280 Villas", Location: "İstanbul / Sarıyer", Date: "2013" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı Holding", Project: "One 6-Storey Waterfront Mansion", Location: "İstanbul / Yeniköy", Date: "2015" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Sinpaş Residential Buildings", Project: "Electrical Works for 2 Villa Buildings", Location: "İstanbul / Kilyos", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Öz Yazıcı Building", Project: "Infrastructure and Environmental Lighting", Location: "İstanbul / Kilyos", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Torunlar Building", Project: "Low-Current Infrastructure Cabling", Location: "İstanbul / Şişli", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Ceylan Building", Project: "Electrical Work for 450 Residential Apartments", Location: "Bolu", Date: "1999" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "TEOS Marin", Project: "Infrastructure and Environmental Lighting for 11 Villas", Location: "İstanbul / Şişli", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Aliç Building", Project: "General Electrical Works", Location: "İstanbul", Date: "2014" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Office / Store"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Office, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Company"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Project"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Location"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Date"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı Holding", Project: "Kanyon Mall Office Floor", Location: "İstanbul / Yeniköy", Date: "2015" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Omak Engineering", Project: "Zorlu Mall ZES Charging Stations", Location: "İstanbul", Date: "2025" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Topkapı Karroser", Project: "Shell Station Office Building", Location: "İstanbul / Topkapı", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı Vitra", Project: "120-Person Office Building", Location: "İstanbul / Tuzla", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı Sport", Project: "Ayazağa Facilities", Location: "İstanbul / Maslak", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Kollektif House", Project: "40 Offices / General Electrical Works", Location: "İstanbul / Şişli", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Social Software", Project: "60-Person Call Center", Location: "İstanbul / Sanayi", Date: "2019" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Integral Media", Project: "Company Office Building", Location: "İstanbul / Halkalı", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "Complete Electrical Works for the 5th Floor", Location: "İstanbul / Levent", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "250-Person Call Center", Location: "İstanbul / Kadıköy", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "Complete Electrical Works", Location: "İstanbul / Ataşehir", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "Complete Electrical Works", Location: "İstanbul / Şişli", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Anadolu Hayat", Project: "Complete Electrical Works", Location: "İzmir / Konak", Date: "2019" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Akvaryum Mall", Project: "Low-Current Installation", Location: "İstanbul / Florya", Date: "2011" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Kanyon Mall", Project: "Residential Floors Renovation", Location: "İstanbul / Levent", Date: "2013" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Divan Hotel", Project: "Office Building Electrical Works", Location: "İstanbul / Ümraniye", Date: "2006" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "ANT Plato", Project: "General Office Building Works", Location: "İstanbul", Date: "2022" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Farmalab", Project: "Kasımpaşa Store", Location: "İstanbul", Date: "2022" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Swaroski", Project: "Kanyon Mall Store", Location: "İstanbul / Levent", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "İş Tower", Project: "Cafeteria Renovation", Location: "İstanbul / Levent", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "İşmer", Project: "General Electrical Works", Location: "İstanbul", Date: "2017" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "JUWO", Project: "Kanyon Mall Store", Location: "İstanbul / Levent", Date: "2019" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "H&M", Project: "3-Storey Store", Location: "İstanbul / Taksim", Date: "2010" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "H&M", Project: "1-Storey Store", Location: "İstanbul / Florya", Date: "2012" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Hotel"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Hotel, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Company"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Project"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Location"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Date"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Stone House Villas", Project: "Electrical Work for 24 Stone Villas", Location: "İzmir / Çeşme", Date: "2003" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Hotel", Project: "Electrical Work for 12-Room Stone Hotel", Location: "İzmir / Çeşme", Date: "2002" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Hospital"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Hospital, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Company"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Project"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Location"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Date"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Dokuz Eylül Hospital", Project: "Electrical Work for 7–8 Blocks", Location: "İzmir / Balçova", Date: "1997" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Yeşilyurt Health Institute", Project: "500-Bed Hospital Building", Location: "İzmir / Yeşilyurt", Date: "1998" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Education Centers"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Education, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Company"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Project"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Location"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Date"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "American Robert College", Project: "Fitness Gym", Location: "İstanbul / Etiler", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "American Robert College", Project: "Social Facility Building", Location: "İstanbul / Etiler", Date: "2018" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "İnciraltı Student Dormitory", Project: "11-Block Dormitory Building", Location: "İzmir / Balçova", Date: "1998" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Sabancı University", Project: "Gymnasium Construction", Location: "İstanbul / Tuzla", Date: "2004" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Güzelbahçe High School", Project: "22-Classroom School Building", Location: "İzmir / Güzelbahçe", Date: "1998" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Bornova High School", Project: "26-Classroom School Building", Location: "İzmir / Bornova", Date: "1998" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Factory"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Factory, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Company"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Project"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Location"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Date"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Eczacıbaşı Pharmaceutical Factory", Project: "Factory Storage Areas", Location: "İstanbul / Ayazağa", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Arslan Aluminum", Project: "Factory Construction", Location: "İstanbul / Beylikdüzü", Date: "2006" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Tofaş", Project: "Automation Panels", Location: "Bursa", Date: "2004" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Hafner Machine", Project: "Factory", Location: "İstanbul / Ayazağa", Date: "2016" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Borusan", Project: "Automation Panels", Location: "İzmit", Date: "2004" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "CMS Jant", Project: "Factory Construction", Location: "İzmir / Çiğli", Date: "2005" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Arçelik", Project: "Automation Panels", Location: "Bolu", Date: "2005" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Vestel", Project: "Automation Panels", Location: "Manisa", Date: "2005" }),
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "B/S/H", Project: "Automation Panels", Location: "Tekirdağ / Çerkezköy", Date: "2005" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "F1"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Formula, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Company"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Project"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Location"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Date"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Divan Hotel", Project: "Formula Grand Prix", Location: "İstanbul / Tuzla", Date: "2007" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Network / Data"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Data, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Company"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Project"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Location"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Date"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "NETAŞ Fatih Project", Project: "Data Infrastructure for 8 Schools", Location: "İstanbul / Tuzla", Date: "2017" })
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB x5i48t" },
                                    //Element
                                    React.createElement(Row, {},
                                        //Element
                                        React.createElement(Col, { md: 2 },
                                            //Element
                                            React.createElement("div", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB d969bo" },
                                                //Element
                                                React.createElement("h3", { className: "S6pt64 C96Q4r pEO064 a527eB fj594i" },
                                                    //Element
                                                    "Dam Electrification"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 3 },
                                            //Element
                                            React.createElement(Water, {})
                                        ),
                                        //Element
                                        React.createElement(Col, { md: 7 },
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB s85b1d" },
                                                //Element
                                                React.createElement(Row, {},
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Company"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 4 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Project"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 3 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Location"
                                                        )
                                                    ),
                                                    //Element
                                                    React.createElement(Col, { md: 5 },
                                                        //Element
                                                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB x99z47" },
                                                            //Element
                                                            "Date"
                                                        )
                                                    )
                                                )
                                            ),
                                            //Element
                                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c274cc" },
                                                //Element
                                                React.createElement(Item, { ID: "0", Company: "Alçe Water Company", Project: "Hydroelectric Dam Electrical Works", Location: "İzmir / Alaçatı", Date: "2002" })
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;